<template>
  <transition name="toast-fade">
    <div v-if="show" class="custom-toast">
      <span class="toast-message">{{ message }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CustomToast',
  props: {
    show: {
      type: Boolean,
      default: false,
      required: true,
    },
    message: {
      type: String,
      default: '',
      validator: value => value.length <= 100,
    },
    icon: {
      type: String,
      default: 'mdi-check-circle',
      validator: value => value.startsWith('mdi-'),
    },
    duration: {
      type: Number,
      default: 2000,
      validator: value => value >= 0 && value <= 10000,
    },
  },
  mounted() {
    // Handle case when component mounts with show already true
    if (this.show && this.duration > 0) {
      setTimeout(() => {
        this.$emit('update:show', false);
      }, this.duration);
    }
  },
  watch: {
    show(newVal) {
      if (newVal && this.duration > 0) {
        setTimeout(() => {
          this.$emit('update:show', false);
        }, this.duration);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.custom-toast {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  background: #3a3a3a;
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  z-index: 9999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(10px);
  width: fit-content;

  // 데스크탑: 상단 중앙에서 100px
  @media (min-width: 960px) {
    top: 100px;
  }

  // 모바일: 하단 중앙에서 100px
  @media (max-width: 959px) {
    bottom: 100px;
  }
}

.toast-message {
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: all 0.3s ease;
}

.toast-fade-enter,
.toast-fade-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(10px);
}
</style>
